import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@shared/authContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Today from './pages/Today';
import CalendarPage from './pages/Calendar';
import Dashboard from './pages/Dashboard';
import MyServiceCalls from './pages/MyServiceCalls';
import Clients from './pages/Clients';
import MyTruckStock from './pages/MyTruckStock';
import Profile from './pages/Profile';
import Messages from './pages/Messages';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Ensure only technician or admin users can access this app
  if (user?.role !== 'technician' && user?.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600 mb-6">
            You don't have permission to access the technician app.
          </p>
          <button
            onClick={() => window.location.href = `${window.location.origin}/admin`}
            className="btn btn-primary"
          >
            Go to Admin Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/today" replace />} />
        <Route path="/today" element={<Today />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/my-service-calls" element={<MyServiceCalls />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/my-truck-stock" element={<MyTruckStock />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/today" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
